<script>
import { checkConsentMixin } from './check-consent-mixin'
import loadScript from './load-script'

export default {
  mixins: [checkConsentMixin],

  props: {
    projectId: {
      type: String,
      required: true
    }
  },

  methods: {
    trackPage() {
      loadScript(`//cdn.optimizely.com/js/${this.projectId}.js`)
    }
  }
}
</script>
